// extracted by mini-css-extract-plugin
export default {"wrapper":"Spinner_wrapper__A30Zn","loader":"Spinner_loader__JT1-W","spin":"Spinner_spin__FmsRt"};